import { scrollTo } from '@/user/homepage-integration'

export default {
  install: (app, options) => {
    function translate(key) {
      return key.split('.').reduce((o, i) => {
        if (o) return o[i]
      }, options)
    }

    function onTabScrollTop() {
      scrollTo(0, 0)
    }

    function envPhase(env, str) {
      return env === str ? true : false
    }

    function isDev() {
      return envPhase(process.env.NODE_ENV, 'development')
    }

    function signinURL() {
      return process.env.CLOUD_LOGIN_URL
    }

    app.config.globalProperties.$translate = translate
    app.config.globalProperties.$onTabScrollTop = onTabScrollTop
    app.config.globalProperties.$isDev = isDev()
    app.config.globalProperties.$subDomain = isDev() ? 'alpha' : 'www'
    app.config.globalProperties.$signinURL = signinURL()
  },
}
